import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initOneSignal } from "@/lib/onesignal";

initOneSignal();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Longer stale + cache windows so once something is loaded, revisiting a
      // page within the session is INSTANT (no spinner / re-fetch flicker).
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});

// International is tiny — warm its page code + data in the background so INT opens instantly.
(window.requestIdleCallback || ((f) => setTimeout(f, 2500)))(() => {
  import("@/pages/NatSchedule"); import("@/pages/NatStandings"); import("@/pages/NatLeaders");
  import("@/lib/api").then(({ api }) => {
    const pre = (queryKey, url, params) => queryClient.prefetchQuery({ queryKey, queryFn: () => api.get(url, params ? { params } : undefined).then((r) => r.data), staleTime: 60_000 });
    pre(["nat-schedule"], "/intl/schedule");
    pre(["nat-standings"], "/intl/standings");
    pre(["intl-teams"], "/intl/teams");
    pre(["nat-leaders"], "/intl/leaders", { limit: 100 });
  });
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
